export default __webpack_public_path__ + "static/media/icon_share_cg.1e59e542.svg";